import { IDoanhNghiepThucTap } from "../../../model/response/category/IDoanhNghiepThucTap";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eDoanhNghiepThucTapActionObj = {
    LOAD_START: undefined,
    LOAD_SUCCESS: {} as IDoanhNghiepThucTap[],
    LOAD_ERROR: "",

    SHOW_EDIT_MODAL: {} as IDoanhNghiepThucTap | undefined,
    CLOSE_EDIT_MODAL: undefined,

    SAVE_START: {} as IDoanhNghiepThucTap,
    SAVE_SUCCESS: undefined,
    SAVE_ERROR: "",

    DELETE_START: 0,
    DELETE_SUCCESS: undefined,
    DELETE_ERROR: "",

}

export const eDoanhNghiepThucTapActionIds = generateActionTypeIds(eDoanhNghiepThucTapActionObj, "DOANH_NGHIEP_THUC_TAP");
export type IDoanhNghiepThucTapActionTypes = IGenericActionType<typeof eDoanhNghiepThucTapActionObj, "DOANH_NGHIEP_THUC_TAP">;